<template>
  <v-form ref="emailtextfield" @submit="$emit('submit')" onSubmit="return false;">
    <StoryCityTextInput
      v-model="email"
      :label="$t('login.email')"
      single-line
      :loading="$apollo.queries.emailExists.loading"
      :rules="rules"
      tabindex="1"
      dense
      outlined
      :error-messages="emailErrors"
      :valid="valid"
      :showValid="email.length > 0 && !preDebounce"
    />
  </v-form>
</template>
<script>
import { SEARCH_USER } from "@/graphql/UserQueries";
import debounce from "@/helpers/debounce";
import StoryCityTextInput from "@/components/Reusable/StoryCityTextInput";
export default {
  components: {
    StoryCityTextInput,
  },
  data() {
    return {
      email: this.value,
      queryAllowed: false,
      queryEmail: "",
      preDebounce: false,
      error: false,
      emailErrors: [],
    };
  },
  props: {
    value: {
      type: String,
      default: "",
    },
    required: {
      type: Boolean,
      default: false,
    },
    currentEmail: {
      type: String,
      default: "",
    },
  },
  apollo: {
    emailExists: {
      query: SEARCH_USER,
      fetchPolicy: "network-only",
      variables() {
        return {
          email: this.queryEmail,
        };
      },
      update(data) {
        this.$refs.emailtextfield.validate();
        return data.users.edges.length > 0;
      },
      skip() {
        return !this.queryAllowed;
      },
    },
  },
  methods: {
    debouncedEmailChange: debounce(function (newValue) {
      this.preDebounce = false
      if (
        this.email && 
        this.email.length > 3 &&
        this.email.toLowerCase() != this.currentEmail.toLowerCase()
      ) {
        this.queryAllowed = true;
        this.queryEmail = newValue;
      } else {
        this.queryAllowed = false;
      }
    }, 500),
    submit() {
      this.$emit('submit');
    }
  },
  computed: {
    loading() {
      return this.$apollo.queries.emailExists.loading;
    },
    rules() {
      if (this.email.length > 0) {
        return [
          () => !!this.email || this.$t("forms.thisFieldIsRequired"),
          () => this.email.indexOf("@") > 0 && this.email.length >= 3 || this.$t('register.pleaseEnterValidEmail'),
          () =>
            !this.emailExists ||
            this.preDebounce ||
            this.loading ||
            this.$t("register.emailInUse"),
          () =>
            this.email.length <= 254 ||
            this.$t("register.emailTooLarge"),
        ];
      }
      return [];
    },
    validEmail() {
      return (this.email && this.email.indexOf("@") > 0 && this.email.length > 3)
    },
    valid() {
      return (
        this.email == this.currentEmail ||
        this.preDebounce == false &&
        this.emailExists == false &&
        this.emailErrors.length == 0 &&
        this.email.length >= 3 &&
        this.email.indexOf("@") > 0 
      );
    },
  },
  watch: {
    email(newValue) {
      this.preDebounce = true;
      this.$emit("input", newValue);
      this.debouncedEmailChange(newValue)
    },
    emailExists: function () {
      this.$refs.emailtextfield.validate();
    },
    valid(newValue) {
      this.$emit("valid", newValue);
    },
  }
}
</script>